import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimarySideBar from '../../../components/common/sideBar/primarySideBar.js';
import InputIterator from '../../../components/common/inputIterator.js';
import AddButtonSection from '../../../components/common/AddButtonSection.js';
import { addRoleFormRender } from '../../../utils/serviceData.js';

/**
 * AddEditRoleModal Component
 * Modal for adding or editing a role
 * 
 * @param {Boolean} visible - Controls modal visibility (true if addNewRole or editRole)
 * @param {Function} onHide - Handler to close the modal
 * @param {Function} onSubmit - Handler for form submission
 * @param {Object} editRole - Role object being edited (null if adding)
 * @param {Boolean} loading - Loading state
 */
export default function AddEditRoleModal({
  visible,
  onHide,
  onSubmit,
  editRole,
  loading,
}) {
  const {
    control,
    handleSubmit,
    formState: { errors, dirtyFields },
    reset,
    setValue,
  } = useForm({});

  // Set form value when editing
  useEffect(() => {
    if (editRole?.role_name) {
      setValue("role_name", editRole.role_name);
    }
  }, [editRole, setValue]);

  // Reset form when modal closes
  useEffect(() => {
    if (!visible) {
      reset();
    }
  }, [visible, reset]);

  const buttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: Object.keys(dirtyFields).length === 0 || loading,
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: onHide,
    },
  ];

  return (
    <PrimarySideBar
      visible={visible}
      onHide={onHide}
      header={
        <div className="sideBar-header">
          {editRole ? "Edit Role" : "Add Role"}
        </div>
      }
    >
      <InputIterator
        control={control}
        errors={errors}
        formRender={addRoleFormRender}
      />
      <div className="pt-3">
        <AddButtonSection buttons={buttons} />
      </div>
    </PrimarySideBar>
  );
}

